<template>

  <div class="side-pane-wrapper">
    <v-btn class="open-button"
           :color="openButtonColor"
           dark
           fab
           small
           :class="{ 'open-button--hide': sidePaneOpen }"
           @click="togglePane()">
      <v-icon>
        {{openIcon}}
      </v-icon>
    </v-btn>

    <v-btn class="close-button"
           :color="closeButtonColor"
           fab
           small
           :class="{ 'close-button--show': sidePaneOpen }"
           @click="togglePane()">
      <v-icon>
        {{closeIcon}}
      </v-icon>
    </v-btn>

    <v-card class="side-pane"
            :class="{ 'side-pane--open': sidePaneOpen }">
      <slot/>
    </v-card>
  </div>

</template>

<script>
  export default {
    name: "SidePaneDrawer",
    props: {
      sidePaneOpen: {
        type: Boolean,
        default: true
      },
      direction: {
        type: String,
        default: 'ltr'
      },
      openButtonColor: {
        type: String,
        default: 'black'
      },
      closeButtonColor: {
        type: String,
        default: 'white'
      }
    },
    methods: {
      togglePane() {
        this.$emit('sidepane-toggle');
      }
    },
    computed: {
      openIcon() {
        return this.direction === 'ltr' ? 'icon-Leftsimple' : 'icon-Rightsimple'
      },
      closeIcon() {
        return this.direction === 'ltr' ? 'icon-Rightsimple' : 'icon-Leftsimple'
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/assets/scss/abstract/_mixins.scss";

  .side-pane {
    z-index: 50;
    width: 300px;
    position: absolute;
    @include i-translate-x(100%);
    top: 0;
    @include i-position-mirror(right, 0);
    height: 100%;
    transition: transform 0.3s;
    overflow: hidden;
    @include hide-scrollbar;

    @include under-supported-size {
      width: 265px;
    }

    &--open {
      @include i-translate-x(0);
      box-shadow: 0 2px 5px 1px rgba(18, 52, 77, 0.2), 0 12px 39px 7px rgba(18, 53, 77, 0.04);
    }
  }

  .v-btn {
    width: 22px;
    height: 22px;
  }

  .open-button {
    position: absolute;
    top: 20px;
    z-index: 2000;
    transition: right 0.3s, left 0.3s;
    border-radius: 15px;
    width: 50px;
    @include i-position-mirror(right, -28px);

    ::v-deep .v-btn__content {
      position: absolute;
      @include i-position-mirror(left, 0);
    }

    &--hide {
      @include i-position-mirror(right, 255px);
      z-index: 0;
      box-shadow: none;

      @include under-supported-size {
        @include i-position-mirror(right, 220px);
      }
    }
  }

  .close-button {
    position: absolute;
    top: 20px;
    @include i-position-mirror(right, -5px);
    z-index: 0;
    transition: right 0.3s, left 0.3s;

    &--show {
      @include i-position-mirror(right, 289px);
      z-index: 60;
      box-shadow: 0 2px 5px 0 rgba(18, 52, 77, 0.16), inset 0 0 1px 0 rgba(18, 53, 77, 0.3);

      @include under-supported-size {
        @include i-position-mirror(right, 254px);
      }
    }
  }
</style>
